import { Divider, Table, TableBody, TableCell, TableRow } from '@mui/material'
import React from 'react'
import _ from 'lodash'

type Props = {
    imageWidth: number
    imageHeight: number
    smilesImgUrl: string
    setLoading?: any
    columns: any
    smilesData: any
}

const SmilesDataViewer: React.FC<Props> = ({
  imageWidth,
  imageHeight,
  smilesImgUrl,
  setLoading,
  columns,
  smilesData,
}) => {
  return (
    <>
      <h4 className="capitalize m-0 mb-4">Smiles Viewer</h4>
      <div className="flex justify-center items-center">
        <img
          width={imageWidth}
          height={imageHeight}
          src={smilesImgUrl}
          onLoad={() => setLoading(false)}
        />
      </div>
      <Divider />
      <Table className="mb-4">
        <TableBody>
          {columns?.map((column: any) => {
            if (!_.has(smilesData, column.field)) {
              return null
            }
            return (
              <TableRow key={column.field}>
                <TableCell className="pl-4">
                  <strong>{column.headerName || column.field}</strong>
                </TableCell>
                <TableCell>{_.get(smilesData, column.field)}</TableCell>
              </TableRow>
            )
          })}
        </TableBody>
      </Table>
    </>
  )
}

export default SmilesDataViewer
